import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHomeStrings } from '../../hooks/useHomeStrings';
import type { HomeWeeklyScheduleItem, DayOfWeek } from '../../model/types';

// JS getDay(): 0=Sun,1=Mon,...,6=Sat → DayOfWeek
const JS_DAY_MAP: DayOfWeek[] = [
  'SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY',
];

function getTodayDayOfWeek(): DayOfWeek {
  return JS_DAY_MAP[new Date().getDay()];
}

interface Props {
  schedule: HomeWeeklyScheduleItem[];
}

export const WeeklyScheduleList: React.FC<Props> = ({ schedule }) => {
  const STRINGS = useHomeStrings();
  const { t } = useTranslation('customer');
  const DAY_LABELS: Record<DayOfWeek, string> = {
    MONDAY: STRINGS.DAY_MONDAY,
    TUESDAY: STRINGS.DAY_TUESDAY,
    WEDNESDAY: STRINGS.DAY_WEDNESDAY,
    THURSDAY: STRINGS.DAY_THURSDAY,
    FRIDAY: STRINGS.DAY_FRIDAY,
    SATURDAY: STRINGS.DAY_SATURDAY,
    SUNDAY: STRINGS.DAY_SUNDAY,
  };
  if ((schedule ?? []).length === 0) return null;

  const today = getTodayDayOfWeek();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {schedule.map((item) => {
        const isToday = item.dayOfWeek === today;
        return (
          <div
            key={item.dayOfWeek}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px 12px',
              borderRadius: 10,
              background: isToday
                ? 'var(--bl-accent-soft, rgba(51, 144, 236, 0.1))'
                : 'transparent',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Typography.Text
                style={{
                  fontSize: 14,
                  fontWeight: isToday ? 600 : 400,
                  color: isToday
                    ? 'var(--bl-accent, #3390ec)'
                    : 'var(--bl-text-primary, inherit)',
                }}
              >
                {DAY_LABELS[item.dayOfWeek]}
              </Typography.Text>
              {isToday && (
                <span
                  style={{
                    fontSize: 10,
                    fontWeight: 500,
                    color: 'var(--bl-accent, #3390ec)',
                    background: 'var(--bl-accent-soft, rgba(51, 144, 236, 0.15))',
                    borderRadius: 4,
                    padding: '1px 6px',
                    lineHeight: '16px',
                  }}
                >
                  {t('bookings.dateHeader.today').toLowerCase()}
                </span>
              )}
            </div>
            <Typography.Text
              style={{
                fontSize: 14,
                fontWeight: isToday && item.open ? 500 : 400,
                color: item.open
                  ? isToday
                    ? 'var(--bl-accent, #3390ec)'
                    : 'var(--bl-text-primary, inherit)'
                  : 'var(--bl-text-muted, #999)',
              }}
            >
              {item.open && item.hours ? item.hours : STRINGS.DAY_CLOSED}
            </Typography.Text>
          </div>
        );
      })}
    </div>
  );
};
